import { Bell } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { useNotifications } from '@/contexts/NotificationsContext'

interface NotificationBellProps {
  className?: string
}

export function NotificationBell({ className }: NotificationBellProps) {
  const { unreadCount } = useNotifications()
  const { t } = useTranslation('app')

  const displayCount = unreadCount > 99 ? '99+' : String(unreadCount)

  return (
    <span
      data-testid="notification-bell"
      className={cn('relative inline-flex items-center justify-center', className)}
    >
      <Bell className="h-4 w-4 text-current" strokeWidth={1.5} />

      {unreadCount > 0 && (
        <span
          aria-label={t('notifications.unreadAria', { count: unreadCount })}
          className="absolute -top-2.5 -right-2.5 flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-primary px-0.5 text-[9px] font-semibold leading-none text-primary-foreground"
        >
          {displayCount}
        </span>
      )}
    </span>
  )
}
